import { Box, HStack, Icon, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { MailIcon, PhoneIcon } from "../../customIcons";
import ICONS from "../../../constants/socialMedia";
import useCopyToClipboard from "../../../hooks/copyToClipboard";

const ContactInfo = ({ email }: any) => {
  const { isCopied, copyToClipboard } = useCopyToClipboard();

  return (
    <VStack
      p={5}
      maxW="424px"
      w="100%"
      bg="#F6FAF9"
      borderRadius="24px"
      gap={0}
      mb={{ base: 16, md: 0 }}
    >
      <VStack
        alignItems="flex-start"
        justifyContent="flex-start"
        w="100%"
        gap={3}
      >
        <HStack gap={0} alignItems="flex-start">
          <PhoneIcon mt={1} fill="#116266" w="24px" h="24px" />

          <VStack gap={0} ml={3} alignItems="flex-start">
            <Text color="#116266" className="medium-text" fontSize="16px">
              Phone
            </Text>

            <Text
              _hover={{ textDecor: "underline" }}
              className="regular-text"
              color="#6A7471"
              fontSize="16px"
            >
              <a href="tel:+1-647-372-0819">+1 647 372 0819</a>
            </Text>
          </VStack>
        </HStack>

        <HStack gap={0} alignItems="flex-start">
          <MailIcon mt={1} fill="#116266" w="24px" h="24px" />
          <VStack gap={0} ml={3} alignItems="flex-start">
            <Text color="#116266" className="medium-text" fontSize="16px">
              E-mail
            </Text>

            <Text
              cursor="pointer"
              onClick={() => copyToClipboard(email)}
              className="regular-text"
              color="#6A7471"
              fontSize="16px"
              _hover={{ textDecor: "underline" }}
            >
              {email}
              {isCopied && (
                <Text
                  color="blackAlpha.600"
                  fontStyle="italic"
                  mb={2}
                  fontSize="14px"
                  className="regular-text"
                  position="absolute"
                >
                  Email has been copied to clipboard!
                </Text>
              )}
            </Text>
          </VStack>
        </HStack>
      </VStack>
      <Stack
        gap={4}
        justifyContent="flex-start"
        display="flex"
        flexDir="row"
        w="100%"
        pt={6}
      >
        {ICONS.map((icon): any => {
          return (
            <a
              key={icon.id}
              target="_blank"
              rel="noopener noreferrer"
              href={icon.link}
            >
              <Box
                position="relative"
                width="36px"
                height="36px"
                borderRadius="99px"
                bg="#116266"
                _hover={{ bg: "#4C9195" }}
              >
                <Icon
                  fill="#fff"
                  top={2.5}
                  right={2.5}
                  position="absolute"
                  width="16px"
                  height="16px"
                  as={icon.icon}
                />
              </Box>
            </a>
          );
        })}
      </Stack>
    </VStack>
  );
};

export default ContactInfo;
